export const defaultProps = {
    items: [],
    redirect: undefined,
};
